import React from "react";
import { WalletInfo } from "../../../models/customer.model";
import CollapseComponent from "../../../components/collapse/collapseComponent";
import { Grid } from "@mui/material";
import CustomerWalletCard from "./CustomerWalletCard";
interface Props {
  walletInfo: WalletInfo[];
  handleDetail: Function;
}
const CustomerHeader = ({ handleDetail, walletInfo }: Props) => {
  return (
    <div>
      <CollapseComponent title="اطلاعات کیف ها">
        <Grid container gap={"15px"} flexDirection={"column"}>
          {walletInfo?.map((wallet, index) => (
            <Grid
              item
              sx={{
                borderBottom:
                  index < walletInfo.length - 1 ? "1px solid #C1C7CB" : "",
              }}
            >
              <CustomerWalletCard
                wallet={wallet}
                key={index}
                handleDetail={handleDetail}
              />
            </Grid>
          ))}
        </Grid>
      </CollapseComponent>
    </div>
  );
};

export default CustomerHeader;
